<div class="agpr-viBrandCard">
    <div class="agpr-viBrandCard-summary">
        <div
            class="agpr-viBrandCard-logo"
            [style.background-color]="logoPlaceholderColor"
        >
            <span>{{ logoPlaceholder }}</span>
        </div>
        <span
            class="agpr-viBrandCard-nameText"
            [agprTooltip]="brand.name"
        >
            {{ brand.name }}
        </span>
    </div>

    <div
        class="agpr-viBrandIdentityReadonlyCard-content"
        [@cardState]="{value: cardState ? 'expanded' : 'collapsed'}"
    >

        @if (brand.nameVariations?.length) {
            <div class="agpr-viBrandCard-field">
                <div class="agpr-viBrandCard-label">
                    {{ 'Common.brandInformation.nameVariations.label' | localize }}
                </div>
                <div class="agpr-viBrandCard-value">
                    {{ brand.nameVariations.join(', ') }}
                </div>
            </div>
        }

        @if (brand.websites?.length) {
            <div class="agpr-viBrandCard-field">
                <div class="agpr-viBrandCard-label">
                    {{ 'Common.brandInformation.websites.label' | localize }}
                </div>
                <div class="agpr-viBrandCard-value">
                    @for (website of brand.websites; track website) {
                        <a
                            class="agpr-viBrandCard-link"
                            [href]="website"
                            target="_blank"
                            rel="noopener noreferrer"
                            [agprTooltip]="website"
                            tooltipPosition="top"
                            [attr.tabindex]="cardState ? null : -1"
                        >
                            {{ website }}
                        </a>
                    }
                </div>
            </div>
        }

        @if (brand.industry) {
            <div class="agpr-viBrandCard-field">
                <div class="agpr-viBrandCard-label">
                    {{ 'Common.brandInformation.industry.label' | localize }}
                </div>
                <div class="agpr-viBrandCard-value">
                    {{ brand.industry }}
                </div>
            </div>
        }

        @if (brand.bio) {
            <div class="agpr-viBrandCard-field">
                <div class="agpr-viBrandCard-label">
                    {{ 'Common.brandInformation.bio.label' | localize }}
                </div>
                <div class="agpr-viBrandCard-value multiline">
                    {{ brand.bio }}
                </div>
            </div>
        }

        @for (info of brand.additionalContext; track info) {
            <div class="agpr-viBrandCard-field">
                <div class="agpr-viBrandCard-label">
                    {{ info.contextTitle }}
                </div>
                <div class="agpr-viBrandCard-value multiline">
                    {{ info.contextInfo }}
                </div>
            </div>
        }
    </div>

    @if (canToggle) {
        <div class="agpr-viBrandCard-toggleButton">
            @let label = cardState ? 'Core.collapse' : 'Core.expand';
            <agpr-button
                [id]="id + '_toggleButton'"
                class="agpr-viBrandCard-toggleButton"
                [style]="buttonType.link"
                [ariaLabel]="label"
                [tooltip]="label"
                tooltipPosition="left"
                [expanded]="cardState"
                (click)="cardState = !cardState"
            >
                <span
                    class="fa-solid agpr-viBrandCard-toggleButton-icon"
                    aria-hidden="true"
                    [ngClass]="{
                        'fa-angle-down': cardState,
                        'fa-angle-up': !cardState
                    }"
                ></span>
            </agpr-button>
        </div>
    }
</div>
